/* istanbul ignore file */
import { boolean as codecBoolean } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const GradingNotificationsEnabledSettingParser = 
/* #__PURE__ */ parsers.object([
    ['name', /* #__PURE__ */ parsers.exactly('GRADING_NOTIFICATIONS_ENABLED')],
    ['value', /* #__PURE__ */ parsers.maybeNull(codecBoolean)],
]);
export class GradingNotificationsEnabledSetting extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return GradingNotificationsEnabledSettingParser.decode(input).map(res => new GradingNotificationsEnabledSetting(res));
    }
    static unsafeDecode(input) {
        return GradingNotificationsEnabledSetting.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return GradingNotificationsEnabledSettingParser.encode(data);
    }
    static schema() {
        return GradingNotificationsEnabledSettingParser.schema();
    }
}
